import { render, staticRenderFns } from "./GlobalWrapper.vue?vue&type=template&id=aac6f0bc&scoped=true&lang=pug&"
import script from "./GlobalWrapper.vue?vue&type=script&lang=js&"
export * from "./GlobalWrapper.vue?vue&type=script&lang=js&"
import style0 from "./GlobalWrapper.vue?vue&type=style&index=0&id=aac6f0bc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aac6f0bc",
  null
  
)

export default component.exports